module.exports = __webpack_public_path__ + "static/media/aws_security_spec.3ff3a667.png";